import { protectWithAccountPermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { PlanManagementPage } from 'features/planManagement'
import { subscriptionQueryOptions } from 'hooks/api/subscriptions'
import { canViewBillingPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/plan/')({
  component: PlanManagementPage,
  loader: ({ context: { queryClient, buildRequest }, params: { subscriptionId } }) => {
    queryClient.prefetchQuery(
      subscriptionQueryOptions(buildRequest, subscriptionId, ['usageQuota', 'latestTier', 'discounts'] as const)
    )
  },
  head: () => ({
    meta: [
      {
        title: withCompanyName('Plan & Usage'),
      },
    ],
  }),
  beforeLoad: protectWithAccountPermissions(canViewBillingPermission),
})
